import { CardBody, CardHeader, Heading, Tabs, TabList, Tab, TabPanels, TabPanel, Flex, } from '@chakra-ui/react';
import React from 'react';
import { localise } from '../../../services/lang/lang';
import InspectionDetailCard from '../../pages/upgrade/InspectionDetail/InspectionDetailCard';
import LocationFindingsContent from './LocationFindingsContent';
import HazardFindingsContent from './HazardFindingsContent';
import { useInspectionDetailContext } from '../../pages/upgrade/InspectionDetail/InspectionDetailProvider';
import LocationFindingsShareContent from './Sharing/LocationFindingsShareContent';
import HazardFindingsShareContent from './Sharing/HazardFindingsShareContent';
import RenderIfElse from '../RenderIf/RenderIfElse';
import SuspenseWrapper from '../SuspenseWrapper/SuspenseWrapper';
const SurveyFindingsWrapper = ({ inspection }) => {
    const { isShare } = useInspectionDetailContext();
    return (React.createElement(InspectionDetailCard, { "data-testid": "survey-findings-wrapper" },
        React.createElement(Tabs, { variant: "button" },
            React.createElement(CardHeader, null,
                React.createElement(Flex, { justifyContent: "space-between" },
                    React.createElement(Heading, { variant: "dk-800-lt-4" }, localise('SURVEY_FINDINGS')),
                    React.createElement(TabList, { "data-testid": "survey_findings_wrapper__tabs", mt: 0 },
                        React.createElement(Tab, { "data-testid": "survey_findings_wrapper__locations_tab" }, localise('LOCATIONS')),
                        React.createElement(Tab, { "data-testid": "survey_findings_wrapper__hazards_tab" }, localise('HAZARDS'))))),
            React.createElement(CardBody, { padding: 0 },
                React.createElement(TabPanels, null,
                    React.createElement(TabPanel, null,
                        React.createElement(SuspenseWrapper, null,
                            React.createElement(RenderIfElse, { condition: !!isShare, then: React.createElement(LocationFindingsShareContent, null), else: React.createElement(LocationFindingsContent, { inspection: inspection }) }))),
                    React.createElement(TabPanel, null,
                        React.createElement(SuspenseWrapper, null,
                            React.createElement(RenderIfElse, { condition: !!isShare, then: React.createElement(HazardFindingsShareContent, null), else: React.createElement(HazardFindingsContent, { inspection: inspection }) }))))))));
};
export default SurveyFindingsWrapper;
